import { markSeen } from '../lib/storage';
import { Icon } from '../ui/Icon';
import { SunGlow } from '../ui/SunGlow';
import styles from './landing.module.css';

export const Landing = ({ onStart, onExplore }: { onStart: () => void; onExplore: () => void }) => {
  const start = () => {
    markSeen();
    onStart();
  };

  const explore = () => {
    markSeen();
    onExplore();
  };

  return (
    <main className={styles.page}>
      <picture>
        <source media="(max-width: 700px)" srcSet="/images/hero-mobile.jpg" />
        <img
          src="/images/hero.jpg"
          alt="Silhouette of a person in a standing yoga pose against a glowing sunrise sky over hills"
          className={styles.photo}
          decoding="async"
          {...{ fetchpriority: 'high' }}
        />
      </picture>
      <div className={styles.wash} aria-hidden="true" />
      <div className={styles.glow} aria-hidden="true">
        <SunGlow position="page" />
      </div>

      <header className={styles.nav}>
        <Icon name="sun" size={26} className={styles.mark} />
        <span className={styles.brand}>Daily Yoga Companion</span>
      </header>

      <section className={styles.content}>
        <p className={styles.eyebrow}>Practice positive energy</p>
        <h1 className={styles.headline}>Transform your body and mind</h1>
        <p className={styles.lead}>Guided yoga, pranayama and meditation with gentle bells. Free, no sign-up.</p>
        <div className={styles.actions}>
          <button className="pill-button" onClick={start}>
            Get started
          </button>
          <button className={`pill-button ${styles.ghost}`} onClick={explore}>
            Explore practices
          </button>
        </div>
      </section>
    </main>
  );
};
